<template>
  <div class="container-fluid navless-content-80 d-flex justify-content-center">
    <div class="row align-self-center w-100">
      <div class="col text-center" v-if="tab === 'login'">
        <h2>登录</h2>
        <form class="actionForm">

          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="phone">手机</span>
            </div>
            <input type="number" class="form-control"  v-model="phone" :disabled="this.loading" aria-describedby="phone">
          </div>

          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="password">密码</span>
            </div>
            <input type="password" class="form-control" v-model="password" :disabled="this.loading" aria-describedby="password">
          </div>
          <button type="button" class="btn btn-primary btn-block" @click="login()" :disabled="this.loading">
            <span class="spinner spinner-border spinner-border-sm" :class="{'hide':!this.loading}"></span>
            登录
          </button>
          <button type="button" class="btn btn-info btn-block" @click="goRegister()" :disabled="this.loading">
            去注册
          </button>
        </form>
      </div>
      <div class="col text-center" v-if="tab === 'register'">
        <h2>注册</h2>
        <form class="actionForm">
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text" id="r_name">用户名</span>
            </div>
            <input type="text" class="form-control" v-model="registerInfo.name" :disabled="this.loading" aria-describedby="r_name" autocomplete="off">
          </div>
          <!-- <div class="form-group">
            <input type="email" class="form-control" v-model="registerInfo.mail" :disabled="this.loading" placeholder="邮箱" autocomplete="off">
          </div> -->
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text" id="r_phone">手机</span>
            </div>
            <input type="phone" class="form-control" v-model="registerInfo.phone" :disabled="this.loading" aria-describedby="r_phone" autocomplete="off">
          </div>
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text" id="r_password">密码</span>
            </div>
            <input type="password" class="form-control" v-model="registerInfo.password" :disabled="this.loading" aria-describedby="r_password" autocomplete="off">
          </div>
          <button type="button" class="registerBtn btn btn-primary btn-block" :disabled="this.loading" @click="register()">
            <span class="spinner spinner-border spinner-border-sm" :class="{'hide':!this.loading}" ></span>
            注册
          </button>
          <button type="button" class="btn btn-danger btn-block" @click="backToLogin()" :disabled="this.loading">
            取消
          </button>
        </form>
      </div>
    </div>
  </div>

</template>

<style scoped>
  *, *:before, *:after {
    transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);
  }
</style>

<script>
import {store} from '../components/store'
import {urls} from '../components/urls'

export default {
    name:'login',
    mixins: [urls],
    data:function(){
      return{
        phone:'',
        password:'',
        loading:false,
        storeData:store.state,
        tab:'login',
        registerInfo:{
          name:'',
          phone:'',
          password:'',
        }
      }
    },
    methods: {
      goRegister:function(){
        // this.$router.push({path:'/register',replace:true});
        this.tab='register';
      },
      clearAll:function(){
        this.phone='';
        this.password='';
        this.registerInfo.name='';
        this.registerInfo.phone='';
        this.registerInfo.password='';
      },
      login:function(){
        this.loading=true;
        this.$axios.post(this.fetchUrl+'/api/login-auth',{phone:this.phone,password:this.password})
        .then(res => {
          this.loading=false;
          let json=res.data;
          if(!json.error){
            // store.login(json);
            // json.password=this.password;
            localStorage.user=JSON.stringify(json);
            this.$bvModal.msgBoxOk('登陆成功', {
              title: '欢迎回来',
              size: 'lg',
              buttonSize: 'sm',
              okVariant: 'success',
              headerClass: 'p-2',
              centered: true
            })
              .then(value => {
                this.$router.push({path:'/home',replace:true});
              })
              .catch(err => {
                // An error occurred
              })
          }else{
            alert("login fail");
          }
        })
        .catch(error => {
          this.loading=false;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        });
      },
      backToLogin:function(){
        // this.$router.push({path:'/login',replace:true});
        this.tab='login';
      },
      register:function(){
        this.loading=true;
        this.$axios.post(this.fetchUrl+'/api/user',this.registerInfo,{timeout: 10000})
        .then(res => {
          let json=res.data;
          if(!json.error){
            alert("注册成功");
            this.clearAll();
            this.tab="login";
          }else{
            alert("注册失败");
          }
          this.loading=false;
        })
        .catch(error => {
          this.loading=false;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        });
      }
    },
    computed:{

    }
}
</script>

